import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import moment from 'moment';
import InputMask from 'react-input-mask';
import {DatePicker} from 'rsuite';
import { asignarPago } from '../../../../actions/payments';

import { useForm } from '../../../../hooks/useForm';
import { formValidation } from '../../../../helpers/formValidation';
export const Ventanilla = () => {

    const dispatch = useDispatch()
    const {asignarVentanillaForm} = useSelector(state => state.forms);

    const [{account, invoice, quantity}, handleInputChange, reset] = useForm({
        account: '',
        invoice: '',
        quantity: ''
    });

    const [startDate, setStartDate] = useState('');

    const handleSubmit= (e)=>{
        formValidation(e, () => dispatch(
            asignarPago(
                'asignarVentanillaForm',
                account, 
                invoice, 
                '', 
                quantity, 
                moment(startDate).format('DD/MM/yyyy'),
                'ventanilla', 
                () =>reset()
            )
        ));
    }


    return (
        <div>
            <form 
                name="asignarVentanillaForm" 
                className="needs-validation needs-validation" 
                noValidate={true} 
                onSubmit={handleSubmit}
            >
                {
                    !!asignarVentanillaForm.msg &&
                        <div className={`alert alert-${asignarVentanillaForm.error?'danger':'success'}`} role="alert">
                            {asignarVentanillaForm.msg}
                        </div>
                }
                <div className="form-row align-items-center mb-0">
                    <div className="col-md-6">
                    <label className="">Cuenta</label>
                        <InputMask 
                            mask="999" 
                            maskChar={null}
                            type="text" 
                            className="form-control mb-2"
                            placeholder="(3 últimos dígitos)" 
                            autoComplete="off" 
                            name="account"
                            required={true}
                            value={account}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="col-md-6">
                    <label className="">No. movimiento / Folio</label>
                        <InputMask 
                            mask="9999999999" 
                            maskChar={null}
                            type="text" 
                            className="form-control mb-2"
                            placeholder="" 
                            autoComplete="off" 
                            name="invoice"
                            required={true}
                            value={invoice}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="col-md-6">
                    <label className="">Fecha de pago</label>
                        <DatePicker 
                            style={{ width: 280 }}
                            value={startDate}
                            onChange={date => setStartDate(date)} 
                            format="dd/MM/yyyy"
                            placeholderText="dd/mm/yyyy"
                            maxDate={new Date()}
                            className="form-control mb-2"
                            autoComplete="off" 
                            name="date"
                            required={true}
                        />
                        {/* <DatePicker 
                            selected={startDate} 
                            onChange={date => setStartDate(date)} 
                            dateFormat="dd/MM/yyyy"
                            placeholderText="dd/mm/yyyy"
                            maxDate={new Date()}
                            className="form-control mb-2"
                            autoComplete="off" 
                            name="date"
                            required={true}
                        /> */}
                    </div>
                    <div className="col-md-6">
                        <label className="">Cantidad</label>
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text" id="inputGroupPrepend">$</span>
                            </div>
                            <input 
                                type="text" 
                                className="form-control" 
                                aria-describedby="inputGroupPrepend" 
                                placeholder="Cantidad a abonar" 
                                name="quantity"
                                required={true} 
                                value={quantity}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>
                    <div className="col-md-12 text-right mt-2">
                        <button 
                            className="btn btn-primary waves-effect waves-light mb-2" 
                            type="submit"
                            disabled={!!asignarVentanillaForm.loading ? true : false}
                        >
                            {!!asignarVentanillaForm.loading && <i className="spinner-border spinner-border-sm" role="status"></i>} Guardar
                        </button>
                    </div>
                </div>
            </form>
        </div>
    )
}
